// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"baf7c239","455":"f0a76b3d"}[chunkId] + ".chunk.js";
};